function getTitleAndNameByDepartment(department: string): string | null {
  const departmentMapping: { [key: string]: string } = {
    LM: 'Dr. Gerardo Hernández Valdez',
    LF: 'Dra. María Concepción Salas Solis',
    LCC: 'Dr. Yazmany Jahaziel Guerrero Ceja',
    LA: 'M.A. Alejandro Vargas Hernández',
    LSTI: 'M.A. Mónica Montemayor Treviño',
    LMAD: 'M.E. Daniel Raúl Acosta Martínez',
    FOGU: 'M.A. Lázaro Treviño Castillo',
  };

  return departmentMapping[department] || null;
}

export { getTitleAndNameByDepartment };
